var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvinbra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 106,
    viewBox: "0 0 128 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.52 41.1992L127.845 26.8721L101.783 0.410156L88.3721 13.7202C99.7091 19.5532 108.689 29.3072 113.52 41.1992Z",
    fill: "#65C080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.476 13.7251L26.366 0.411133L0.0140381 26.5601L14.423 40.9831C19.274 29.1911 28.212 19.5211 39.476 13.7251Z",
    fill: "#65C080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.24 29.8321C87.219 21.8141 76.163 16.8631 63.927 16.8621C51.692 16.8631 40.637 21.8151 32.615 29.8311C24.599 37.8531 19.648 48.9081 19.646 61.1441C19.647 73.3781 24.599 84.4331 32.615 92.4551C40.637 100.473 51.692 105.423 63.927 105.425C76.162 105.423 87.219 100.473 95.24 92.4551C103.258 84.4341 108.208 73.3791 108.21 61.1441C108.209 48.9071 103.258 37.8531 95.24 29.8321Z",
    fill: "#65C080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.583 77.262C80.583 86.46 73.125 93.912 63.928 93.912C54.732 93.912 47.275 86.458 47.275 77.262C47.275 68.059 54.732 60.604 63.928 60.604C73.125 60.604 80.583 68.061 80.583 77.262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.851 81.6881C73.7057 81.6881 76.02 79.3738 76.02 76.5191C76.02 73.6643 73.7057 71.3501 70.851 71.3501C67.9962 71.3501 65.682 73.6643 65.682 76.5191C65.682 79.3738 67.9962 81.6881 70.851 81.6881Z",
    fill: "#65C080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.009 81.6881C59.8637 81.6881 62.178 79.3738 62.178 76.5191C62.178 73.6643 59.8637 71.3501 57.009 71.3501C54.1542 71.3501 51.84 73.6643 51.84 76.5191C51.84 79.3738 54.1542 81.6881 57.009 81.6881Z",
    fill: "#65C080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.396 55.009C89.7631 55.009 94.114 50.6581 94.114 45.291C94.114 39.9239 89.7631 35.573 84.396 35.573C79.0289 35.573 74.678 39.9239 74.678 45.291C74.678 50.6581 79.0289 55.009 84.396 55.009Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.464 55.009C48.8311 55.009 53.182 50.6581 53.182 45.291C53.182 39.9239 48.8311 35.573 43.464 35.573C38.0969 35.573 33.746 39.9239 33.746 45.291C33.746 50.6581 38.0969 55.009 43.464 55.009Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvinbra);
export default __webpack_public_path__ + "static/media/svinbra.58edc325e3bbb13a9f82f49cd5785a4b.svg";
export { ForwardRef as ReactComponent };